{
    "Profile_Residents_Claim.claim": "FR: Claim",
    "Profile_Residents_Claim.claimDetails": "FR: Claim Details",
    "Profile_Residents_Claim.dateOfClaim": "FR: Date of Claim",
    "Profile_Residents_Claim.claimReason": "FR: Claim Reason",
    "Profile_Residents_Claim.lossAmount": "FR: Loss Amount",
    "Profile_Residents_Claim.currentRisk": "FR: Current Risk"
}
